<template>
  <MRow :gutter="0" class="justify-between items-center flex-no-wrap">
    <div v-if="name" class="overflow-visible flex items-center">
      <slot name="before-title"></slot>
      <span
        :class="
          internalLink && link && view !== 'split' ? 'cursor-pointer' : ''
        "
        class="resource-name-pill text-ellipsis"
        style="white-space: nowrap"
        :tabindex="0"
        role="button"
        @click="onPillClick"
        @keydown.enter="onPillClick"
      >
        {{ name }}
      </span>
    </div>
    <MCol class="text-ellipsis">
      <component
        :is="internalLink && link ? (openInNewTab ? 'a' : 'FlotoLink') : 'div'"
        class="resource-title-container"
        v-bind="
          internalLink && link
            ? {
                ...(openInNewTab ? {} : { to: hrefLink }),
                ...(openInNewTab ? { target: '_blank', href: hrefLink } : {}),
              }
            : {}
        "
      >
        <component
          :is="externalLink ? 'span' : 'h5'"
          :tabindex="externalLink ? -1 : 0"
          :aria-label="name"
          class="subject-title font-normal list-title"
          @keydown.enter="($event) => $emit('click', $event)"
        >
          <span
            v-if="subject"
            :class="view === 'split' ? 'text-primary' : 'text-neutral'"
            class="text-left"
            >{{ subject }}</span
          >
          <span v-if="markResourceArchived">{{ `(${$tc('archived')})` }}</span>
        </component>

        <span
          class="flex items-center"
          :class="{ 'justify-between': view === 'split' }"
        >
          <small
            v-if="createdAt"
            class="text-neutral text-ellipsis flex items-center"
          >
            <FlotoUserDrawer
              v-if="ownerId && view !== 'split'"
              :user-id="ownerId"
              show-avatar
              :disabled="true"
            />

            <FlotoDotSeparator
              v-if="ownerId && view !== 'split'"
              class="mx-1"
            />
            <span>
              <MIcon
                v-if="createdAt && view !== 'split' && view !== 'list'"
                name="clock"
                size="lg"
                class="text-primary mx-1"
              />
              <span :class="{ 'text-light': view === 'split' }">
                {{ createdAt | datetime }}
              </span>
            </span>
          </small>
          <FlotoUserAvatar
            v-if="ownerId && view === 'split'"
            :user-id="ownerId"
            show-avatar
            :disabled="true"
            :size="20"
            show-tooltip
          />
          <slot name="below-title"></slot>
        </span>
      </component>
    </MCol>
    <MCol
      v-if="externalLink && link"
      auto-size
      class="hover-action-container text-right"
      @click.stop
    >
      <FlotoLink
        class="icon-button rounded"
        :tabindex="-1"
        :aria-label="`${name} ${subject || ''}`"
        target="_blank"
        :to="link"
      >
        <MIcon name="external-link" />
      </FlotoLink>
    </MCol>
  </MRow>
</template>

<script>
import { TechnicianComputed } from '@state/modules/technician'
export default {
  name: 'ResourceListTitle',
  props: {
    name: { type: String, default: '' },
    subject: { type: String, default: '' },
    createdAt: { type: Number, default: null },
    requesterName: { type: String, default: '' },
    requesterEmail: { type: String, default: '' },
    link: { type: Object, default: undefined },
    externalLink: { type: Boolean, default: false },
    userId: { type: Number, default: undefined },
    openInNewTab: { type: Boolean, default: false },
    // eslint-disable-next-line
    internalLink: { type: Boolean, default: true },
    markResourceArchived: { type: Boolean, default: false },
    ownerId: { type: Number, default: undefined },
    view: { type: String, default: 'list' },
  },
  computed: {
    ...TechnicianComputed,
    hrefLink() {
      return this.$router.resolve(this.link).href
    },
    ownerName() {
      return (
        this.requesterName ||
        this.requesterEmail ||
        (this.userId ? this.technician(this.userId) || {} : {}).name
      )
    },
  },
  methods: {
    onPillClick(event) {
      if (!this.link) return
      if (this.view === 'split') return
      if (this.openInNewTab) {
        window.open(this.hrefLink, '_blank')
      } else {
        this.$router.push(this.link)
      }
    },
  },
}
</script>

<style lang="less" scoped>
.list-title {
  font-size: var(--font-size-base);
}

.resource-title-container:has(.title-content) {
  @apply flex flex-col;
}

.text-neutral {
  color: var(--page-text-color) !important;
}

.icon-button {
  &:hover {
    background-color: var(--default-button-hover-bg);
  }
}
</style>
